import { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Button } from "primereact/button"

import styles from "../../../../styles/TwoFA.module.css"

import { getAuth, sendEmailVerification } from "firebase/auth"

export default function EmailVerification({ emailVerified, reloadUser }) {
  const [checkingVerification, setCheckingVerification] = useState(false)
  const [emailSent, setEmailSent] = useState(false)
  const [msg, setMsg] = useState("")
  const [loading, setLoading] = useState(false)

  const user = getAuth().currentUser

  // Polling for email verification every 5 seconds
  useEffect(() => {
    let interval
    if (checkingVerification) {
      interval = setInterval(async () => {
        console.count("Polling on email verification")
        await reloadUser()
      }, 5000)
    }
    return () => clearInterval(interval)
  }, [checkingVerification])

  // Stop polling when user.emailVerified updates
  useEffect(() => {
    if (emailVerified && checkingVerification) {
      console.log("Email verification detected! Stopping polling.")
      setCheckingVerification(false)
    }
  }, [user, user.emailVerified])

  async function handleEmailVerification() {
    // const auth = getAuth()
    setLoading(true)
    try {
      await sendEmailVerification(user)
      setEmailSent(true)
      setCheckingVerification(true)
    } catch (error) {
      setMsg(error.message)
      console.log(error, "Error sending email verification")
    } finally {
      setLoading(false)
    }
  }

  function checkEmailVerification() {
    if (emailVerified) {
      return (
        <div className={styles.block}>
          ✅ Your email <strong>{user.email}</strong> is verified. You can now
          enable 2FA.
        </div>
      )
    }
    return (
      <div className={styles.block}>
        <div>
          Your email <strong>{user.email}</strong> is not verified. Please
          verify your email first.
        </div>
        <Button
          label={
            loading
              ? "Sending verification..."
              : "Click here to verify your email"
          }
          onClick={() => handleEmailVerification()}
          disabled={emailSent || loading} // Disable button if email is sent or loading
          style={{ marginTop: 15 }}
        />
      </div>
    )
  }

  return (
    <div className={styles.block}>
      <h2>Step 1: Email Verification</h2>
      {msg !== "" && <div>{msg}</div>}
      {checkEmailVerification()}
    </div>
  )
}

EmailVerification.propTypes = {
  // user: PropTypes.shape({
  //   email: PropTypes.string.isRequired,
  //   emailVerified: PropTypes.bool.isRequired,
  // }).isRequired,
  reloadUser: PropTypes.func.isRequired,
}
